/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useMemo } from "react";
import { Button, IconButton } from "@material-tailwind/react";
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import { PaginationType } from "@/utils/interface.global";
import { usePagination } from "@/hooks/usePagination";

interface Props {
  currentPage: number;
  pagination: PaginationType | null;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const Pagination: React.FC<Props> = ({
  currentPage,
  setCurrentPage,
  pagination,
}: Props) => {
  const [active, setActive] = useState(currentPage);
  const totalCount = pagination && pagination.total;
  const pageSize = pagination && pagination.limit;
  const totalPage = pagination && pagination.totalPage;
  const paginationRange = usePagination({
    currentPage,
    totalCount: totalCount as number,
    pageSize: pageSize,
    totalPage: totalPage as number
  });
  const lastPage =
    paginationRange && paginationRange[paginationRange.length - 1];

  const getItemProps = (index: number) =>
    ({
      variant: active === index ? "filled" : "text",
      color: active === index ? "red" : "blue-gray",
      onClick: () => {
        setCurrentPage(index);
        setActive(index);
      },
      className: "rounded-full",
    } as any);

  const next = () => {
    if (active === lastPage) return;
    setCurrentPage(active + 1);
    setActive(active + 1);
  };
  const prev = () => {
    if (active === 1) return;
    setCurrentPage(active - 1);
    setActive(active - 1);
  };

  const renderPagination = useMemo(() => {
    return (
      paginationRange &&
      paginationRange.map((pageNumber) => {
        if (pageNumber === "...") {
          return (
            <IconButton
              key={`pagination: ${pageNumber}`}
              // {...getItemProps(pageNumber as number)}
              className="w-8 h-8"
            >
              {pageNumber}
            </IconButton>
          );
        }
        return (
          <IconButton
            key={`pagination: ${pageNumber}`}
            {...getItemProps(pageNumber as number)}
            className="w-8 h-8"
          >
            {pageNumber}
          </IconButton>
        );
      })
    );
  }, [paginationRange]);

  return (
    <div className="flex items-center">
      <Button
        variant="text"
        color="blue-gray"
        className="flex items-center"
        onClick={prev}
        disabled={active === 1}
      >
        <ArrowLeftIcon strokeWidth={2} className="h-2 w-2" />
      </Button>
      <div className="flex items-center gap-1">{renderPagination}</div>
      <Button
        variant="text"
        color="blue-gray"
        className="flex items-center"
        onClick={next}
        disabled={active === lastPage}
      >
        <ArrowRightIcon strokeWidth={2} className="h-2 w-2" />
      </Button>
    </div>
  );
};
export default Pagination;
